import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  UPDATE_SYSTEM_SETTING,
  GET_SYSTEM_SETTING,
  CLEAR_MESSAGE,
} from "./actionTypes"

export const settingsApiSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
})

export const settingsApiFail = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
})

export const getSettingData = () => ({
  type: GET_SYSTEM_SETTING,
})

export const updateSetting = (settingId, data) => ({
  type: UPDATE_SYSTEM_SETTING,
  payload: { settingId, data },
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})
